// extracted by mini-css-extract-plugin
module.exports = {"center":"Login_center__TfAGH"};